<div class="cx-cart-item">
  <!-- Item Start Outlet -->
  <ng-template [cxOutlet]="CartOutlets.ITEM">
    <div [ngClass]="compact ? 'cx-compact row' : 'row'">
      <!-- Item Image -->
      <div class="col-2 cx-image-container">
        <a [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl" cxModal="dismiss" tabindex="-1">
          <cx-media [container]="item.product.images?.PRIMARY" format="cartIcon"></cx-media>
        </a>
      </div>
      <!-- Item Information -->
      <div class="cx-info col-10">
        <div class="cx-info-container row">
          <!-- Item Description -->
          <div [ngClass]="compact ? '' : ' col-md-3 col-lg-3 col-xl-5'">
            @if (item.product.name) {
              <div class="cx-name">
                <a
                  class="cx-link"
                  [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
                  cxModal="dismiss"
                  >{{ item.product.name }}</a
                  >
                </div>
              }
              @if (item.product.code) {
                <div class="cx-code">
                  {{ 'cartItems.id' | cxTranslate }} {{ item.product.code }}
                </div>
              }

              <!-- Item Details Outlet -->
              <ng-template [cxOutlet]="CartOutlets.ITEM_DETAILS"> </ng-template>

              <!-- Variants -->
              @if (item.product.baseOptions?.length) {
                @for (variant of item.product.baseOptions[0]?.selected?.variantOptionQualifiers; track variant) {
                  <div
                    class="cx-property"
                    >
                    @if (variant.name && variant.value) {
                      <div class="cx-label">
                        {{ variant.name }}: {{ variant.value }}
                      </div>
                    }
                  </div>
                }
              }
            </div>
            <!-- Item Price -->
            @if (item.basePrice) {
              <div class="cx-price" [ngClass]="compact ? '' : ' col-md-3 col-lg-3 col-xl-2'">
                <div class="cx-label" [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'">
                  {{ 'cartItems.itemPrice' | cxTranslate }}
                </div>
                @if (item.basePrice) {
                  <div class="cx-value">
                    {{ item.basePrice?.formattedValue }}
                  </div>
                }
              </div>
            }
            <!-- Item Quantity -->
            <div class="cx-quantity" [ngClass]="compact ? '' : ' col-3'">
              <div
                class="cx-label"
                [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'"
                placement="left"
                title="{{ 'cartItems.quantityTitle' | cxTranslate }}"
                >
                {{ 'cartItems.quantity' | cxTranslate }}
              </div>
              <div class="cx-value">
                {{ item.quantity }}
              </div>
            </div>
            <!-- Total -->
            @if (options.isSaveForLater) {
              <div class="cx-total" [ngClass]="compact ? '' : ' col-md-3 col-lg-3 col-xl-2'">
                <div class="cx-label" [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'">
                  {{ 'saveForLaterItems.stock' | cxTranslate }}
                </div>
                @if (item.product?.stock?.stockLevel >= 0) {
                  <div class="cx-value">
                    {{ item.product.stock.stockLevel }}
                  </div>
                } @else {
                  <div class="cx-value">
                    {{ 'saveForLaterItems.forceInStock' | cxTranslate }}
                  </div>
                }
              </div>
            } @else {
              @if (item.totalPrice) {
                <div class="cx-total" [ngClass]="compact ? '' : ' col-md-3 col-xl-2'">
                  <div class="cx-label" [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'">
                    {{ 'cartItems.total' | cxTranslate }}
                  </div>
                  <div class="cx-value">{{ item.totalPrice.formattedValue }}</div>
                </div>
              }
            }
          </div>
          <!-- Availability -->
          @if (showStockStatus && isProductOutOfStock(item.product)) {
            <div class="cx-availability col-12">
              {{ 'addToCart.outOfStock' | cxTranslate }}
            </div>
          }

          <!-- Promotion -->
          @if (appliedProductPromotions$ | async; as appliedProductPromotions) {
            <cx-promotions [promotions]="appliedProductPromotions"></cx-promotions>
          }
        </div>
      </div>

    </ng-template>
  </div>
